import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { NewFooter } from "../../components/newFooter";
import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";
import { useEffect } from "react";
import { useDispatch } from "react-redux"
import { getPractitionerUsers } from "../../features/auth/authSlice";
import { getPractitionerProfiles } from "../../features/practitionerProfiles/practitionerProfileSlice"
import "../../styles/PractitionerProfileStyles.css";
import "../../styles/index.css";
import "../../styles/userprofileview.css"

export function PractitionerProfileUserView() {
  const { practitionerUsers } = useSelector((state) => state.auth)
  const { practitionerProfiles } = useSelector((state) => state.practitionerProfiles)
  const [practitioner, setPractitioner] = useState(null)
  const [profile, setProfile] = useState(null)
  const params = useParams();
  const dispatch = useDispatch()
  console.log("Practitioner: ", practitioner)
  console.log("Profile: ", profile)

  const getPractitionerInfo = () => {
    let individual = practitionerUsers.find((item) => item._id === params.practitioner_id)
    setPractitioner(individual)
    let profileInfo = practitionerProfiles.find((item) => item._id === individual.profile)
    setProfile(profileInfo)
  }

  useEffect(() => {
    if (practitionerUsers.length > 0 && practitionerProfiles.length > 0) {
      getPractitionerInfo()
    } else {
      dispatch(getPractitionerUsers())
      dispatch(getPractitionerProfiles())
    }
  }, [])

  useEffect(() => {
    getPractitionerInfo()
  }, [practitionerUsers, practitionerProfiles])

  useEffect(() => {
    getPractitionerInfo()
  }, [])

  return (
    <div className="">
      <MDBContainer className="container-profile p-5">
        <MDBRow>

          {/* Left Column - Image and User Info */}
          <MDBCol className="mb-4 d-flex justify-content-center">
            <div className="first-section-profile ">
              <div>
                <div className="photo-secction-user">
                  <img src={profile?.image} className="image-profile" alt="profile" />
                </div>
              </div>

              {practitioner && <div>
                <div className="name-profile ms-4">
                  <h3 className="text-al">{practitioner.specialty === "Physician (MD)" ? `Dr. ${practitioner.firstName} ${practitioner.lastName}` : `${practitioner.firstName} ${practitioner.lastName}`}</h3>
                </div>
                <div className="ms-4 mt-0">
                  <h6 className="text-al fs-22-18">Practice Name</h6>
                  <p className="text-dm">{practitioner.practiceName}</p>
                  <h6 className="text-al fs-22-18">Specialty</h6>
                  <p className="text-dm">{practitioner.specialty}</p>
                  {/* <h6 className="text-al fs-22-18">Sub-Specialties</h6>
                  <p className="text-dm">{practitioner.subSpecialty.map((item, index, arr) => {
                    if (index === arr.length - 1) {
                      return (`${item}`)
                    } else {
                      return (`${item}, `)
                    }
                  })}</p> */}
                  <h6 className="text-al fs-22-18">Practice Address</h6>
                  <p className="text-dm">{practitioner.practiceAddress}</p>
                  <h6 className="text-al fs-22-18">Practice Phone Number</h6>
                  <p className="text-dm">{practitioner.practicePhoneNumber}</p>
                  <h6 className="text-al fs-22-18">Education</h6>
                  <p className="text-dm">{profile?.education}</p>
                  <h6 className="text-al fs-22-18">Years of Experience</h6>
                  <p className="text-dm">{profile?.yearsOfExperience}</p>
                  {(profile?.instagramUrl || profile?.facebookUrl || profile?.linkedinUrl) && <h6 className="text-al fs-22-18">Social Media</h6>}
                  {(profile?.instagramUrl || profile?.facebookUrl || profile?.linkedinUrl) && <div className="d-flex pb-2">
                    {profile?.instagramUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={`https://www.instagram.com/${profile?.instagramUrl}/`}><i className="fab fa-instagram" /></a></div>}
                    {profile?.facebookUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={`https://www.facebook.com/${profile?.facebookUrl}/`}><i className="fab fa-facebook-square" /></a></div>}
                    {profile?.linkedinUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={`https://www.linkedin.com/in/${profile?.linkedinUrl}/`}><i className="fab fa-linkedin" /></a></div>}
                    {profile?.websiteUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={profile?.websiteUrl}><i className="fas fa-globe"></i></a></div>}
                  </div>}
                </div>
              </div>}
            </div>
          </MDBCol>

          {/* Middle Column - Profile Info */}
          <MDBCol className="second-secction-profile d-flex justify-content-center ">
            <div>
              <div className="bg-profile-input-two mb-4 p-3 pe-1">
                <h4 className="ps-2 pt-2  text-al">About me</h4>
                <div className="dimention text-break"><p className="text-center-profile-userview text-dm over">{profile?.aboutMe}</p></div>
              </div>

              <div className="bg-profile-input-two mb-4 p-3 pe-1">
                <div>
                  <h4 className="ps-2 pt-2  m-2 text-al">How I Can Help</h4>
                  <div className="dimention text-break"> <p className="text-center-profile-userview text-dm over">{profile?.howCanIHelp}</p></div>
                </div>
              </div>

              <div className="bg-profile-input-two mb-4 p-3 pe-1">
                <div>
                  <h4 className="ps-2 pt-2   text-al">Services Offered</h4>
                  <div className="dimention text-break"> <p className="text-center-profile-userview text-dm over">{profile?.servicesOffered}</p></div>
                </div>
              </div>

              <div className="bg-profile-input-two mb-4 p-3 pe-1">
                <h4 className="ps-2 pt-2  text-al">Sub-Specialties</h4>
                <div className="dimention text-break">
                  <p className="text-center-profile-userview text-dm over">
                  <p className="">{practitioner?.subSpecialty?.map((item, index, arr) => {
                    if (index === arr.length - 1) {
                      return (<span className="text-dm text-black">{`${item}`}</span>)
                    } else {
                      return (<span className="text-dm text-black">{`${item}, `}</span>)
                    }
                  })}</p>
                  </p>
                  </div>
              </div>

              <div className="bg-profile-input-certifications p-3 pe-1">
                <div>
                  <h4 className="ps-2 pt-2 text-al">Certifications</h4>
                  <div className="text-center-profile-userview">
                  {profile?.certifications.map((item, index, arr) => {
                    if(index === arr.length - 1){
                      return(
                      <span className="text-dark text-dm">{item}</span>
                      )
                    } else {
                      return(
                      <span className="text-dark text-dm">{item}, </span>
                      )
                    }
                  })}
                  </div>
                </div>


              </div>
            </div>
          </MDBCol>

          {/* Right Column - Profile Info Continued */}
          <MDBCol order='' className="d-flex justify-content-center">
            <div className="">
              <div className="availability mb-4 p-3 pe-1">
                <h4 className="mx-3 mb-3 pt-2 text-al">Availability</h4>
                <div className="availability-box-user d-flex justify-content-center align-items-center">
                  <Link to={`/calendar/${params.practitioner_id}`}>
                    <MDBBtn disabled={practitioner?.calendlyUrl ? false : true} className="blue-hover">
                      {practitioner?.calendlyUrl ? "Book Now" : "Coming Soon"}
                    </MDBBtn>
                  </Link>
                </div>
              </div>

              <div className="policy-user p-3 pe-1">
                <h4 className="m-3 pt-3 text-al">Cancellation Policy</h4>
                <p className="text-center-profile-userview text-dm"> Should you need to cancel or rescheduled an appointment, please contact our office no later than 24 hours prior to your scheduled appointment.</p>
              </div>

              <div className="certification mt-3 p-3 pe-1">
                <h4 className="m-3 pt-2 whitespace text-al">Payment Methods</h4>
                {/* <span className="m-3 pt-2 plus-button">+</span> */}
              </div>
            </div>
          </MDBCol>

        </MDBRow>
      </MDBContainer>
      <NewFooter />
    </div>
  );
}
